import React from "react";
import Sellorderpage from "Pages/Sellorder";


const Sellordertheme = () => {
  return (
    <React.Fragment>
       <Sellorderpage/>
    </React.Fragment>
  );
};

export default Sellordertheme;
